import FiveStarRatingDisplay from './FiveStarRatingDisplay_v2';
import FiveStarRating from './FiveStarRating_v2';

export default FiveStarRatingDisplay;
export { FiveStarRating };
